// // Comment these three lines in standalone mode
import { appendMyBetsPlinko, setBetLock, setDemoMyBets, setPlacedBetData } from "games/Plinko/slices-thunks/plinkoGame.slice.js"
import store from "redux-store/store.js"

import { boxBounceEffect, changeNumberOfLines, clearAllBalls, createBall, removeLightningMode, setupPayoutText, startMovingBall } from "./gameUI.js"
import { playBGMSound, playLeftDropSound, playOrangeBoxSound, playRedBoxSound, playRightDropSound, playYellowBoxSound } from "./soundManager.js"
import { dequeueCreditWalletWaitQueue, updateCreditDemoWalletWaitQueue, updateDemoWalletBalance } from "redux-store/redux/slices/auth.slice.js"
import { isPixiStandAlone } from "./settings.js"
import { DEFAULT_PLINKO_LIGHTNING_MODE_BOARD } from "../plinkogame.constants.js"
import { setShowWinAmt } from "games/Plinko/slices-thunks/plinkoGame.slice.js"
import { countOnes } from 'utils/common-functions/index.js'

let autoBet = false
let noOfBalls = 0

export function pixiSetAutoBet (_autoBet = false) {
  autoBet = _autoBet
}

export function pixiGetAutoBet () {
  return autoBet
}

export function pixiGetNoOfBalls () {
  return noOfBalls
}

export function pixiIncrementNoOfBalls () {
  noOfBalls = 1
}

export function pixiSetNoOfBalls (_noOfBalls) {
  noOfBalls = _noOfBalls
}

export const pixiCreateBall = (lastBall, winAmt) => createBall(lastBall, winAmt)

export const pixiStartMovingBall = (ballPath) => {
  pixiIncrementNoOfBalls()
  const ballPathArray = ballPath.split('').map(ele => +ele)
  startMovingBall(ballPathArray)
}

export const pixiCancelBall = () => clearAllBalls()

export const pixiChangeNumberOfLines = (lines) => changeNumberOfLines(lines)

export const pixiSetPayouts = (payouts) => setupPayoutText(payouts)


export const boxNumbers = {
  Red: 1,
  Orange: 2,
}

export const boxColor = {
  yellow: 0xf6c36b,
  orange: 0xe7635e,
  red: 0xe34a5c,
  white: 0xFFFFFF,
  pink: 0xFF629A,
  alpha: 1
}

export const fastModeBox = (dropDetails) => {
  // Comment these lines in standalone mode
  const boxNumber = countOnes(dropDetails)
  boxBounceEffect(boxNumber)
}


export const dispatching = (isLastBall, currentBetWinningAmount) => {
  // Comment this line in standalone mode
  if (!isPixiStandAlone) {
    dispatchRoundEnd(currentBetWinningAmount)
  }
  if (isLastBall) {
    pixiSetNoOfBalls(0)
    store.dispatch(setBetLock())
    store.dispatch(setPlacedBetData(null));
  }
}

export const dispatchRoundEnd = (currentBetWinningAmount) => {
  const demoMode = store.getState()?.auth?.demoMode
  const demoWallet = store.getState()?.auth?.demoWallet
  if (demoMode) {
    if (demoMode) store.dispatch(setDemoMyBets())
    store.dispatch(updateDemoWalletBalance(demoWallet.balance + currentBetWinningAmount))
  } else store.dispatch(dequeueCreditWalletWaitQueue())
  store.dispatch(setShowWinAmt(true))
  store.dispatch(updateCreditDemoWalletWaitQueue())
  store.dispatch(appendMyBetsPlinko())
}

const data = [
  {
    position: [1, 1],
    multiplier: "3x"
  },
  {
    position: [4, 5],
    multiplier: "7x"
  },
  {
    position: [6, 7],
    multiplier: "12x"
  }
]

export const pixiLightningMode = (
  ballMultipliers = DEFAULT_PLINKO_LIGHTNING_MODE_BOARD.betMultipliers,
  payouts = DEFAULT_PLINKO_LIGHTNING_MODE_BOARD.payouts
) => {
  // lightningModeUI(ballMultipliers)
  // pixiSetPayouts(payouts)
}

export const pixiNormalMode = (payouts) => {
  removeLightningMode()
  pixiSetPayouts(payouts)
}

// Sounds
export const playBGM = () => {
  // Background Music
  playBGMSound()
}
export const playRightDrop = () => {
  playRightDropSound()

}
export const playLeftDrop = () => {
  playLeftDropSound()

}
export const playYellowBox = () => {
  playYellowBoxSound()

}
export const playOrangeBox = () => {
  playOrangeBoxSound()

}
export const playRedBox = () => {
  playRedBoxSound()
}
